import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'ba-modal',
  templateUrl: './baModal.html'
})
export class BaModalComponent {
  @Input() title: string = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'sm';
  @Input() config: any = { backdrop: 'static' };

  @Output() onShown: EventEmitter<void> = new EventEmitter<void>();
  @Output() onHidden: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild("modal") modal?: ModalDirective;

  open(): void {
    if (this.modal) {
      this.modal.show();
    }
  }

  close(): void {
    if (this.modal) {
      this.modal.hide()
    }
  }

  // Backwards compatibility with existing code using show/hide
  show(): void { this.open(); }
  hide(): void { this.close(); }

  get isShown() {
    return this.modal.isShown;
  }

  handleShown(): void {
    this.onShown.emit();
  }

  handleHidden(): void {
    this.onHidden.emit();
  }
}


